import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizePageSchema, resolveCanonical } from '../seo/pageSchema';
import { setSchema } from '../seo/headManager';

const StructuredData = ({ type, data, id = 'additional-page-schema' }) => {
  const { pathname } = useLocation();
  const schema = type === 'LocalBusiness' ? null : normalizePageSchema(data, resolveCanonical(pathname));
  const serialized = JSON.stringify(schema || null);
  useLayoutEffect(() => setSchema(id, JSON.parse(serialized), Symbol(id)), [id, serialized]);
  return null;
};
export default StructuredData;